export default __webpack_public_path__ + "static/5-projects-windows-f30a0517f3a2a953bd3e3fd5d7f2b957.jpg";